// src/social/caption-generator.js
// Generates random captions using templates

import { hooks, templates, roomFeatures, amenities, greetings, occasions, cities, landmarks, seasons, holidays, guestQuotes, offerDetails, benefits } from './caption-templates';
import { generateHashtags } from './hashtags';

// Get random item from array
function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// Get random hook
function getHook() {
  const type = getRandom(['emoji', 'words', 'questions']);
  return getRandom(hooks[type]);
}

// Replace placeholders in template
function fillTemplate(template, vars) {
  let result = template;
  for (const [key, value] of Object.entries(vars)) {
    result = result.replace(new RegExp(`\\{${key}\\}`, 'g'), value);
  }
  return result;
}

// Generate caption based on property and post type
export function generateCaption(property, postType, city) {
  const template = getRandom(templates[postType] || templates.room);
  
  const vars = {
    hook: getHook(),
    propertyName: property.name,
    city: city || property.city || 'California',
    roomFeature: getRandom(roomFeatures),
    amenity: getRandom(amenities),
    greeting: getRandom(greetings),
    occasion: getRandom(occasions),
    landmark: getRandom(landmarks),
    season: getRandom(seasons),
    holiday: getRandom(holidays),
    guestQuote: getRandom(guestQuotes),
    guestReview: getRandom(guestQuotes),
    offerDetails: getRandom(offerDetails),
    benefit: getRandom(benefits),
    roomDescription: getRandom(roomFeatures),
    roomType: getRandom(roomFeatures)
  };
  
  return fillTemplate(template, vars);
}

// Generate hashtags
export function generatePostHashtags(property, postType, city) {
  const currentMonth = new Date().getMonth();
  let season = null;
  
  if (currentMonth >= 2 && currentMonth <= 4) season = 'Spring';
  else if (currentMonth >= 5 && currentMonth <= 7) season = 'Summer';
  else if (currentMonth >= 8 && currentMonth <= 10) season = 'Fall';
  else season = 'Winter';
  
  return generateHashtags(property.name, postType, city || property.city, season);
}

// Get current season
export function getCurrentSeason() {
  const month = new Date().getMonth();
  if (month >= 2 && month <= 4) return 'Spring';
  if (month >= 5 && month <= 7) return 'Summer';
  if (month >= 8 && month <= 10) return 'Fall';
  return 'Winter';
}
